<div #hubSpendChart id="hub-spend-chart-id" (window:resize)="onResize()"></div>